import { render, staticRenderFns } from "./dealright.vue?vue&type=template&id=1980f96b&scoped=true&"
import script from "./dealright.vue?vue&type=script&lang=js&"
export * from "./dealright.vue?vue&type=script&lang=js&"
import style0 from "./dealright.vue?vue&type=style&index=0&id=1980f96b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1980f96b",
  null
  
)

export default component.exports